module.exports = __webpack_public_path__ + "img/parallel.b45073ca.png";